// Texts for error page
const error = {
    urlNotFound: 'No pudimos encontrar la página que estás buscando.',
    pageLoadingError: 'Ocurrió un error al cargar la página.',

    productsLoadingError: 'Ocurrió un error al cargar los productos.',
    noProductFound: 'No se encontraron productos.',

    productLoadingError: 'Ocurrió un error al cargar el producto.',

    loginError: 'Ocurrió un error al iniciar sesión.',

    textEmptyError: 'Ingresa un texto.',

    updateError: 'Ocurrió un error al actualizar los datos.',

    invalidImageTypeError: 'Las imágenes deben estar en formato .jpg, .jpeg o .png.',
    tooManyImagesError: 'No se pueden agregar más de 5 imágenes.',

    unauthorizedPageError: 'Acceso denegado. Credenciales no autorizadas.',

    aboutInfoEmptyError: 'Debes completar todos los campos.',

    productNameEmptyError: 'El nombre del producto no puede estar vacío.',
    productPriceEmptyError: 'El precio del producto no puede estar vacío.',

    productHaveBeenModifiedError: 'No se pudo editar el producto. Fue modificado en otra ventana. Probá de nuevo.',

    productCreationError: 'No se pudo crear el producto.',
    productDeletionError: 'No se pudo eliminar el producto.',
    productEditionError: 'No se pudieron guardar los cambios del producto.',
    imageEditionError: 'Ocurrió un error al actualizar las imágenes del producto.',

    statisticsLoadingError: 'Ocurrió un error al cargar las estadísticas.',

    failedToLoadVisitPerDayError: 'No se pudieron cargar las visitas por día.',
    failedToLoadViewPerProductError: 'No se pudieron cargar las vistas por producto.',
    failedToLoadVisitPerLocationError: 'No se pudieron cargar las visitas por ubicación.'
};

export default error;
